import { useQueryClient } from '@tanstack/react-query';
import { useAxiosQuery, useAxiosMutation } from './use-axios.hook';
import { GetAllTemplateFilesApiRequest } from '../../../../types/requests/templates/files/get-all-template-files.request';
import { createTemplateFile, deleteTemplateFile, getAllTemplateFiles } from '../../api/template-files.api';
import { DeleteTemplateFileApiRequest } from '../../../../types/requests/templates/files/delete-template-file.request';
import { CreateTemplateFileApiRequest } from '../../../../types/requests/templates/files/create-template-file.request';

const baseQueryKey = 'template-file';

export const useGetAllTemplateFiles = (params: GetAllTemplateFilesApiRequest) => {
  const { data, ...result } = useAxiosQuery({
    queryKey: [baseQueryKey, params],
    queryFn: async () => (await getAllTemplateFiles(params)).data,
    enabled: Boolean(params.templateId && !Number.isNaN(params.templateId)),
  });
  return { ...result, templateFiles: data } as const;
};

export const useCreateTemplateFile = () => {
  const queryClient = useQueryClient();
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: CreateTemplateFileApiRequest) => (await createTemplateFile(params)).data,
    onSuccess: (_, { templateId }) =>
      queryClient.invalidateQueries({
        predicate: ({ queryKey }) =>
          queryKey[0] === baseQueryKey && (queryKey[1] as GetAllTemplateFilesApiRequest)?.templateId === templateId,
      }),
  });
  return [request, result] as const;
};

export const useDeleteTemplateFile = () => {
  const queryClient = useQueryClient();
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: DeleteTemplateFileApiRequest) => (await deleteTemplateFile(params)).data,
    onSuccess: (_, params) =>
      queryClient.invalidateQueries({
        predicate: ({ queryKey }) =>
          queryKey[0] === baseQueryKey &&
          (queryKey[1] as GetAllTemplateFilesApiRequest)?.templateId === params.templateId,
      }),
  });
  return [request, result] as const;
};
